import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { DynamicFormService } from 'src/app/shared/forms/dynamic-form/dynamic-form.service';

@Component({
    selector: 'formly-text-with-toggle',
    templateUrl: "./formly-text-with-toggle.component.html",
    standalone: false
})
export class FormlyTextWithToggleComponent extends FieldType implements OnInit, OnDestroy {
    param: any;
    isFormSubmitted: boolean = false;
    formSubmissionSubscription: Subscription;
    fieldKey: string;
    constructor(private dynamicFormService: DynamicFormService) {
        super();
    }

    ngOnInit() {
        if (this.field.key) {
            this.fieldKey =this.field.id??this.field.key.toString();
        }
        this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
            this.isFormSubmitted = data;
        });
    }

    ngOnDestroy() {
        if (this.formSubmissionSubscription) {
            this.formSubmissionSubscription.unsubscribe();
        }
    }

    onValueChange(value) {
        this.formControl.setValue(value);
        if (this.to && typeof this.to.change === 'function') {
            this.to.change(this.field, value);
        }
    }
  }